import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle, faPencil } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, DashboardModule, Link,
} from '@domain-group/suit-theme'

import useCustomItemGroup from '@hooks/useCustomItemGroup'
import useCustomItem from '@hooks/useCustomItem'
import useCustomItems from '@hooks/useCustomItems'

import type { CustomItemGroupModel } from '@models/types'

import CustomItem from '../CustomItem'

interface CustomItemGroupProps {
  customItemGroup: CustomItemGroupModel,
}

const CustomItemGroup = (props: CustomItemGroupProps) => {
  const { customItemGroup } = props
  const { agency_id, title } = customItemGroup

  const {
    callbacks: { createOrEditCustomItemGroup },
  } = useCustomItemGroup(customItemGroup)

  const customItemsPayload = useCustomItems({
    filters: {
      agency_id,
      custom_item_group_id: customItemGroup.id,
    },
  })

  const {
    filteredCustomItems,
    hasFilteredCustomItems,
  } = customItemsPayload

  const {
    callbacks: { createOrEditCustomItem },
  } = useCustomItem({ agency_id, custom_item_group_id: customItemGroup.id })

  return (
    <DashboardModule
      boxProps={{ marginBottom: 'large' }}
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={(
        <Link onClick={createOrEditCustomItemGroup} greyLink textProps={{ fontSize: 'small' }}>
          <FontAwesomeIcon icon={faPencil} />
        </Link>
      )}
      title={title}
    >
      {!hasFilteredCustomItems && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            You don&apos;t have any custom items.
          </DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>
            Add a custom item.
          </DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      )}

      {hasFilteredCustomItems && (
        <Box flexDirection="column">
          {filteredCustomItems.map(customItem => (
            <CustomItem key={customItem.id} customItem={customItem} />
          ))}
        </Box>
      )}

      <DashboardModule.Footer>
        <DashboardModule.FooterRight>
          <Button
            buttonStyle="secondaryEdit"
            icon={<FontAwesomeIcon icon={faPlusCircle} />}
            onClick={() => createOrEditCustomItem()}
            // @ts-expect-error TS2322
            size={['medium', 'small']}
            width={['100%', 'fit-content']}
          >
            Add Item
          </Button>
        </DashboardModule.FooterRight>
      </DashboardModule.Footer>
    </DashboardModule>
  )
}

export default CustomItemGroup
